import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  pr: 2,
};

export const accordion: SxStyle = {
  backgroundColor: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(0),
  borderColor: (p) => p.palette.grey[300],
  color: (p) => p.palette.grey[500],
  borderLeft: 0,
  borderRight: 0,
  borderBottom: 0,
};

export const detail: SxStyle = {
  borderRadius: (p) => p.spacing(0),
  border: 0,
};

export const accordionTitle: SxStyle = {
  fontSize: (p) => p.typography.subtitle2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[800],
};
